import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useState } from 'react';
import { selected_device_for_device_maintenance, } from 'console/tabs/maintenance/utils/selectors';
import { createHistoryMaintenance, deleteHistoryMaintenance, editHistoryMaintenance, } from 'console/tabs/maintenance/Actions_Reducers/HistoryMaintenanceActions';
import { useCounter } from '@uidotdev/usehooks';
import { HistoryMaintenanceDialog, } from 'console/tabs/maintenance/history/dialog';
import { Box, Button } from '@mui/material';
import { PlannedNotification } from 'console/tabs/maintenance/notification';
import { HistoryMaintenanceTable } from 'console/tabs/maintenance/history/table';
import * as S from './styles';
import { Add } from '@mui/icons-material';
import { SettingCard, SettingFullRow, } from 'z3k-settings/components/material-utils/settings-card';
import { ActualMileage } from 'console/tabs/maintenance/actual-mileage';
import { useAction, useAppSelector } from 'console/shared/hooks/redux/hooks';
import { useBooleanState } from 'console/shared/hooks/state/boolean';
import { usePartial } from 'console/shared/hooks/utils';
import { ColumnBox } from 'shared/components/containers';
export const MaintenanceTab = memo(function MaintenanceTab() {
    const device = useAppSelector(selected_device_for_device_maintenance);
    const work_state = useMemo(() => (device != null ? device.work_state ?? null : null), [device?.work_state]);
    const device_maintenances = useMemo(() => (device != null ? device.maintenances ?? null : null), [device?.maintenances]);
    const onCreateHistoryMaintenance = useAction(createHistoryMaintenance);
    const onEditHistoryMaintenance = useAction(editHistoryMaintenance);
    const onDeleteHistoryMaintenance = useAction(deleteHistoryMaintenance);
    const [dialog_opened, closeDialog, openDialog] = useBooleanState(false);
    const [count, { increment }] = useCounter();
    const _openDialog = useCallback(() => {
        openDialog();
        increment();
    }, []);
    const [temp_maintenance, setTempMaintenance] = useState(null);
    const onOpenHistoryDialog = useCallback((maintenance) => {
        setTempMaintenance(maintenance);
        _openDialog();
    }, []);
    const onCreateMaintenance = usePartial(onOpenHistoryDialog, null);
    const onApplyHistoryDialog = useCallback((data) => {
        if (device?.id == null) {
            return;
        }
        //Сохраняем ТО
        if (data.created) {
            onCreateHistoryMaintenance(device.id, {
                ...data.new_maintenance,
                id: device.id.toString() +
                    '-' +
                    (device_maintenances != null
                        ? device_maintenances.history.length
                        : 0).toString(),
            });
        }
        else {
            onEditHistoryMaintenance(device.id, data.new_maintenance);
        }
    }, [
        onCreateHistoryMaintenance,
        device?.id,
        device_maintenances,
        onEditHistoryMaintenance,
    ]);
    const onDeleteDialog = useCallback((maintenance_id) => {
        if (device?.id == null) {
            return;
        }
        onDeleteHistoryMaintenance(device.id, maintenance_id);
    }, [device?.id]);
    if (device == null) {
        return null;
    }
    return (_jsxs(Box, { height: "100%", mx: 2, children: [_jsxs(S.MaintenanceTab, { children: [_jsxs(ColumnBox, { boxSizing: "border-box", width: "100%", children: [_jsx(ActualMileage, { device_id: device.id }), _jsx(PlannedNotification, { device_planned_notification: device_maintenances?.planned_notification ?? null, device_id: device.id })] }), _jsx(SettingCard, { title: "\u0418\u0441\u0442\u043E\u0440\u0438\u044F \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F", header_props: {
                            action: (_jsx(Button, { startIcon: _jsx(Add, {}), variant: "outlined", onClick: onCreateMaintenance, sx: { mr: 1 }, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C" })),
                        }, children: _jsx(SettingFullRow, { children: _jsx(HistoryMaintenanceTable, { device_maintenances: device_maintenances, onEditHistoryMaintenance: onOpenHistoryDialog }) }) })] }), _jsx(HistoryMaintenanceDialog, { open: dialog_opened, onClose: closeDialog, maintenance: temp_maintenance, work_state: work_state, onApply: onApplyHistoryDialog, onDeleteMaintenance: onDeleteDialog, device_id: device.id }, count)] }));
});
